// src/main.js

import { createApp } from 'vue';
import App from './App.vue';
import { createVuetify } from 'vuetify';
import { PublicClientApplication } from "@azure/msal-browser";
import router from './router';
import axios from 'axios';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import { createI18n } from 'vue-i18n';

// Import translation files
import en from './locales/en.json';
import se from './locales/se.json';

// Configure i18n
const i18n = createI18n({
  locale: navigator.language.slice(0, 2) || 'en',
  fallbackLocale: 'en',
  messages: { en, se }
});

const vuetify = createVuetify();
const isDemoMode = process.env.VUE_APP_DEMO_MODE === 'true';

function mountApp(account = null) {
  const app = createApp(App);
  app.provide('account', account);
  app.use(vuetify);
  app.use(router);
  app.use(i18n);
  app.mount('#app');
}

// MSAL configuration
const msalInstance = new PublicClientApplication({
  auth: {
    clientId: "0137a64b-ba6e-4994-8381-0acc0c89dc4f",
    authority: "https://login.microsoftonline.com/8b12f282-f648-4fe1-ad67-d10c7fbf40a0",
    redirectUri: window.location.origin
  }
});

async function bootstrap() {
  if (isDemoMode) {
    mountApp({
      name: 'Daniel Ekdahl',
      username: 'daniel.ekdahl@consid.se',
      idTokenClaims: { oid: 'c852c0ae-fbf8-4f0c-8f72-8d2461c677f1' },
    });
    return;
  }

  await msalInstance.initialize();

  // Handle redirect response from Azure
  const response = await msalInstance.handleRedirectPromise();

  if (response) {
    msalInstance.setActiveAccount(response.account);
  }

  let account = msalInstance.getActiveAccount();

  if (!account) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      account = accounts[0];
      msalInstance.setActiveAccount(account);
    }
  }

  // If still no account → redirect to login
  if (!account) {
    await msalInstance.loginRedirect({
      scopes: ["api://0137a64b-ba6e-4994-8381-0acc0c89dc4f/user_impersonation"]
    });
    return;
  }

  // Acquire access token for backend API
  const tokenResponse = await msalInstance.acquireTokenSilent({
    scopes: ["api://0137a64b-ba6e-4994-8381-0acc0c89dc4f/user_impersonation"],
    account: account
  });

  // Attach token to all axios requests
  axios.defaults.headers.common["Authorization"] =
    `Bearer ${tokenResponse.accessToken}`;

  // Create and mount Vue app AFTER authentication
  mountApp(account);
}

bootstrap();
